import {
  type ComicPageLayoutTemplate,
  getPageLayoutDefinition,
  layoutGridContainerStyle,
  layoutSlotCss,
} from '../../lib/comicPageLayout'

/** 页内分格示意：按槽位描边（主题色见 index.css --comic-layout-divider） */
export function ComicPageLayoutSkeletonOverlay({
  layout,
  className = '',
  faint = false,
}: {
  layout: ComicPageLayoutTemplate
  className?: string
  /** 有成图叠在下方时略淡 */
  faint?: boolean
}) {
  const def = getPageLayoutDefinition(layout)

  return (
    <div
      className={[
        'pointer-events-none absolute inset-0 grid gap-0',
        faint ? 'opacity-45' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={layoutGridContainerStyle(layout)}
      aria-hidden
    >
      {def.slots.map((slot, i) => (
        <div
          key={i}
          className="border border-[color:var(--comic-layout-divider,var(--line))]"
          style={layoutSlotCss(slot)}
        />
      ))}
    </div>
  )
}
